import FileView from "./FileView";

const FileContainer = () => {
  return <FileView />;
};

export default FileContainer;
